import { statItems } from '@/mocks/home';

export default function YearNumbers() {
  return (
    <section className="bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">全年数据</p>
          <h2 className="font-heading text-2xl font-black tracking-tight md:text-4xl">数字会说话</h2>
          <p className="text-sm text-foreground-700 md:text-base">这是今年吃瓜群众一起攒下的共同记忆。</p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-background-200 bg-background-200 sm:grid-cols-2 lg:grid-cols-4">
          {statItems.map((s, i) => (
            <div key={s.label} className="bg-background-100 px-6 py-7">
              <div className="flex items-end gap-1">
                <span
                  className={`font-label text-4xl font-extrabold leading-none md:text-5xl ${
                    i === 1 ? 'text-accent-600' : 'text-foreground-950'
                  }`}
                >
                  {s.value}
                </span>
                {s.unit && <span className="pb-0.5 text-base font-bold text-foreground-600">{s.unit}</span>}
              </div>
              <p className="mt-3 text-sm font-semibold text-foreground-900">{s.label}</p>
              <p className="mt-1 text-xs text-foreground-600">{s.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}